import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Image from "next/image";
import Loading from "../../../components/Loading";
import ProgramNameCard from "../../../components/program/ProgramNameCard";
import useProgramName from "../../../service/program/name/useProgramName";
import Dialog from "../../../components/Dialog";

export default function name() {
  const {
    query: { name },
  } = useRouter();

  const { data, program, fetching } = useProgramName(name);
  const [video, setVideo] = useState(false);

  const detectKeyDown = (e) => {
    if (e.key === "Escape") {
      setVideo(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", detectKeyDown, true);
  }, []);

  const schemeData = {
    "@type": "Program",
    data: data,
  };

  return (
    <main className="relative h-full w-full pt-20 lg:pt-28">
      <Head>
        <title>
          Program {program.name} | Wardaya Online by Wardaya College
        </title>
        <meta name="description" content={`${program.short_description}`} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemeData),
          }}
        />
      </Head>

      <div className="mx-auto flex h-[28rem] w-full items-center justify-center bg-white/60">
        <div className="absolute top-20 -z-10 flex h-[28rem] w-full lg:top-28">
          <Image
            src={program?.background ? program.background : "/images/logo.png"}
            alt={program.name}
            title={program.name}
            layout="fill"
            objectFit="cover"
            priority={true}
          />
        </div>
        <div className="flex h-full w-full max-w-[1280px] flex-col gap-2 py-5 px-5 md:gap-5 lg:py-20">
          <h1 className="bg-gradient-to-tr from-[#142D59] to-[#308FD8] bg-clip-text text-center font-nunito text-3xl font-extrabold capitalize text-transparent md:text-left md:text-4xl">
            Program Kelas {program.name}
          </h1>
          <div
            className="text-justify font-nunito text-sm font-semibold md:text-left md:text-lg"
            dangerouslySetInnerHTML={{
              __html: program?.description,
            }}
          ></div>
          {program.video ? (
            <button
              className="flex h-10 w-36 items-center justify-between rounded-full border-[3px] border-[#0784B0] px-5 opacity-70 hover:opacity-100"
              onClick={() => setVideo(true)}
            >
              <p className="font-nunito text-lg font-semibold">Video</p>
              <img
                src="/images/videoProgram.svg"
                alt={`video program ${program.name}`}
                className="-rotate-90"
              />
            </button>
          ) : null}
        </div>
      </div>

      <div className="mx-auto flex max-w-[1280px] flex-col px-3">
        <div className="mt-12 w-full pb-24">
          <ul className="grid grid-cols-2 gap-2 md:gap-5 lg:grid-cols-4">
            {data.map((item, key) => (
              <ProgramNameCard
                key={key}
                name={item.name}
                description={item.description}
                cover={item.cover ? item.cover : "/images/logo.png"}
                link={item.link}
                slug={name}
              />
            ))}
          </ul>
        </div>
      </div>

      {video ? (
        <Dialog setState={() => setVideo(false)}>
          <div className="flex w-full items-center justify-center">
            <video
              width="400"
              controls={true}
              preload="none"
              src={program.video}
            />
          </div>
        </Dialog>
      ) : null}

      {fetching ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
    </main>
  );
}
